function rollDie(sides) {
    return Math.floor(Math.random() * sides) + 1;
}
/**
 * Parse and roll a dice formula such as `2d6+3`, `d20`, `1d8-1+2d4`.
 * Returns the total, a human-readable breakdown, and the raw rolls.
 * Ported from the legacy `utils.js#rollFormula`.
 */
export function rollFormula(formula) {
    const cleaned = (formula || '').replace(/\s+/g, '').toLowerCase();
    const tokenRe = /([+-]?)(\d*)d(\d+)|([+-]?\d+)/g;
    let total = 0;
    let modifier = 0;
    const rolls = [];
    const parts = [];
    let match;
    while ((match = tokenRe.exec(cleaned)) !== null) {
        if (match[3]) {
            const sign = match[1] === '-' ? -1 : 1;
            const count = match[2] ? parseInt(match[2], 10) : 1;
            const die = parseInt(match[3], 10);
            const values = [];
            let subtotal = 0;
            for (let i = 0; i < count; i += 1) {
                const v = rollDie(die);
                values.push(v);
                subtotal += v;
            }
            total += sign * subtotal;
            rolls.push({ die, values });
            parts.push(`${sign === -1 ? '-' : parts.length ? '+' : ''}${count}d${die}[${values.join(',')}]`);
        }
        else if (match[4]) {
            const flat = parseInt(match[4], 10);
            modifier += flat;
            total += flat;
            parts.push(`${flat >= 0 ? (parts.length ? '+' : '') : ''}${flat}`);
        }
    }
    return { total, breakdown: parts.join(' ') || '0', rolls, modifier };
}
/** D&D ability modifier from a score. */
export function abilityMod(score) {
    return Math.floor((score - 10) / 2);
}
/** Format a modifier with explicit sign, e.g. 3 -> "+3", -1 -> "-1". */
export function modStr(mod) {
    return mod >= 0 ? `+${mod}` : `${mod}`;
}
/** Slugify a title into a URL/file-safe slug. */
export function slugify(input) {
    return input
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 64);
}
/** Generate a reasonably unique id (no external deps). */
export function generateId(prefix = 'id') {
    const rand = Math.random().toString(36).slice(2, 10);
    return `${prefix}-${Date.now().toString(36)}-${rand}`;
}
//# sourceMappingURL=utils.js.map